// extracted by mini-css-extract-plugin
export default {"container":"u2-z"};